import React, { useState, useCallback } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { useLanguage } from '../../../../contexts/LanguageContext';

const RejectRefundDialog = ({ visible, onHide, onReject, isRejecting }) => {
    const { th } = useLanguage();
    const [rejectReason, setRejectReason] = useState('');
    const [error, setError] = useState('');

    const handleReject = useCallback(() => {
        if (!rejectReason?.trim()) {
            setError(th('vehicleRefundOrders.rejectDialog.reasonRequired'));
            return;
        }
        setError('');
        onReject(rejectReason.trim());
    }, [onReject, rejectReason, th]);

    const handleHide = useCallback(() => {
        setRejectReason('');
        setError('');
        onHide();
    }, [onHide]);

    const dialogFooter = (
        <div className="flex justify-content-end gap-2">
            <Button
                label={th('vehicleRefundOrders.buttons.cancel')}
                icon="pi pi-times"
                className="p-button-outlined"
                onClick={handleHide}
                disabled={isRejecting}
            />
            <Button
                label={th('vehicleRefundOrders.buttons.reject')}
                icon="pi pi-times-circle"
                className="p-button-danger"
                onClick={handleReject}
                loading={isRejecting}
            />
        </div>
    );

    return (
        <Dialog
            visible={visible}
            onHide={handleHide}
            header={th('vehicleRefundOrders.rejectDialog.title')}
            footer={dialogFooter}
            style={{ width: '450px' }}
            modal
            closable={!isRejecting}
            closeOnEscape={!isRejecting}
        >
            <div className="p-fluid">
                <div className="field">
                    <label htmlFor="rejectReason" className="font-medium mb-2 block">
                        {th('vehicleRefundOrders.rejectDialog.reasonLabel')} *
                    </label>
                    <InputTextarea
                        id="rejectReason"
                        value={rejectReason}
                        onChange={(e) => {
                            setRejectReason(e.target.value);
                            if (error) setError('');
                        }}
                        rows={5}
                        placeholder={th('vehicleRefundOrders.rejectDialog.reasonPlaceholder')}
                        disabled={isRejecting}
                        autoResize
                        className={error ? 'p-invalid' : ''}
                    />
                    {error && <small className="p-error block mt-1">{error}</small>}
                </div>
            </div>
        </Dialog>
    );
};

export default RejectRefundDialog;
